import { SearchBar } from '@ui/common/search-bar.tsx';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  useDisclosure,
  Select,
  SelectItem,
} from '@heroui/react';
import { Location } from 'iconsax-react';
import {
  type ILocationsItemProps,
  LocationsList,
} from '@ui/location/locations-list';
import { AllStoresList } from '@features/store/all-stores-list';
import { useAtomValue } from 'jotai/index';
import { citiesAtom, cityAtom } from '@app/atoms/app/city.atom.ts';

export const StorePage = () => {
  const selectedCity = useAtomValue(cityAtom);
  const cities = useAtomValue(citiesAtom);

  const [query, setQuery] = useState('');

  const mapped = cities
    .map<ILocationsItemProps | undefined>((locationItem) => {
      return {
        name: locationItem?.name?.toString(),
        value: locationItem?.id.toString(),
      };
    })
    .filter((i) => {
      if (i && query.length > 0 && i.name) {
        return i.name.toLowerCase().search(query.toLowerCase()) >= 0;
      } else {
        return true;
      }
    });

  const set = useNavbar();
  const [storeQuery, setStoerQuery] = useState('');
  const [selectedCityId, setSelectedCityId] = useState<number>(selectedCity.id);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    set.store();
  }, []);
  return (
    <>
      <div className="mt-12 container max-w-7xl mx-auto hidden lg:block">
        <h1 className="text-4xl text-[#222222] font-bold">Аптеки</h1>
      </div>

      <div className="hidden lg:flex flex-row container max-w-7xl mx-auto gap-x-6 mt-9">
        <Select
          label="Город"
          className="max-w-[380px]"
          onSelectionChange={(key) => {
            const value = [...key];
            if (value.length > 0) setSelectedCityId(Number(value[0]));
          }}
          selectedKeys={[selectedCityId.toString()]}
        >
          {mapped.map((location) => (
            <SelectItem key={location!.value}>{location?.name}</SelectItem>
          ))}
        </Select>
        <SearchBar
          placeholder="Поиск по адресу"
          onChange={setStoerQuery}
          isEditable
        />
      </div>
      <div className="flex flex-row items-center justify-between gap-x-3 py-4 lg:hidden">
        <SearchBar onChange={setStoerQuery} isEditable />

        <Button
          size="md"
          radius="lg"
          className="bg-[#F5F5F5] w-11 h-11"
          isIconOnly
          onPress={onOpen}
          startContent={<Location size="24" color="#9CA5AC" />}
        />
      </div>

      <div className="lg:mx-auto container max-w-7xl lg:mt-6 lg:pb-56">
        <AllStoresList query={storeQuery} selectedCityId={selectedCityId} />
      </div>

      <Drawer
        size="3xl"
        hideCloseButton
        radius="lg"
        isOpen={isOpen}
        placement="bottom"
      >
        <DrawerContent>
          <DrawerHeader className="flex flex-col gap-1">
            Фильтр по городу
          </DrawerHeader>
          <Divider />
          <DrawerBody className="min-h-64">
            <SearchBar
              onChange={setQuery}
              placeholder="Поиск по городу"
              isEditable
            />

            <LocationsList
              isDivided
              items={mapped}
              onSelect={(cityId: string) => {
                setSelectedCityId(Number(cityId));
              }}
              value={selectedCityId.toString()}
            />
          </DrawerBody>
          <DrawerFooter>
            <Button size="lg" fullWidth color="primary" onPress={onClose}>
              Сохранить
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
